import {BaseCommandMessage, BaseResponseMessage} from "./base";

/**
 * Сообщение серверу о том, что пользователь, пришедший по рекламе, дошёл до чата.
 *
 * Сам постбек в рекламную сеть уходит только с сервера: запрос из браузера режут блокировщики
 * и его тривиально подделать из devtools, а конверсия стоит рекламодателю денег.
 * Клиент лишь передаёт идентификатор клика, пойманный на лендинге.
 *
 * Подробности — `docs/specs/ad-postback.md`.
 */
export namespace AdConversionCommandNamespace {
    export const COMMAND = 'ad_conversion';

    export class Request extends BaseCommandMessage {
        constructor(readonly clickId: string, readonly network: string) {
            super(COMMAND);
        }
    }

    export class Response extends BaseResponseMessage {
        /**
         * `success: true` означает «сервер взял идентификатор на себя», в том числе когда конверсия
         * по этому клику уже была зарегистрирована раньше. Только в этом случае клиенту можно
         * удалять клик из localStorage. При любой другой ситуации клик остаётся, и попытка повторится.
         */
        constructor(override readonly id: number) {
            super(COMMAND, id, true);
        }
    }
}
